const timeDate                = require('../../../../../js-handler/time-date')
const {escapeTransactionText} = require('../transaction/transaction-dt-handler')

export const tableDetail = {
    entity: 'accountreconciliation',
    dest: 'accountreconciliation',
    tdDataDetail: `data-detail='{"click":[{"dest":"ripple"},
        {"dest":"accountreconciliation","elem":"fullcont","id":"accountreconciliation-fullcont","act":"selectOne","entity":"accountreconciliation","dbid":"#dbid"}],
        "clickRight":[{"dest":"accountreconciliation","elem":"dt","act":"trMenu","id":"trMenu","dbid":"#dbid"}]}'`,
    filter: {
        mainFilterFields: ['accounts.name'],
        mainFilterValues: [''],
        andFilterFields: [''],
        andFilterValues: [''],
    },
}

export function organizeRow(data) {
    if (data.length === 0) {
        return [{
            id: 'nothing',
            colum: [
                { label: 'No Results', span: '' },
                { label: '', span: '' },
                { label: '', span: '' },
            ],
        }]
    }
    return data.map((row) => ({
        id: row.id,
        colum: [
            { label: escapeTransactionText(row.account_name), span: escapeTransactionText(row.code) },
            { label: row.transaction_count, span: 'Transactions' },
            { label: row.date_dt || timeDate.getdateshort(row.date + 'T00:00:00'), span: '' },
        ],
    }))
}
